enum SwitchToImmediateChargingDialogIntl {
    ALL_TIMERS_DISABLED = 'e4c.vehicles.details.allTimersDisabledMessage',
    ALL_TIMERS_DELETED = 'e4c.vehicles.details.allTimersDeletedMessage',
    CANCEL_BUTTON = 'e4c.global.cancel',
    CONFIRM_BUTTON = 'e4c.global.confirm',
    TITLE = 'e4c.confirmationDialog.title.warning',
}

export default SwitchToImmediateChargingDialogIntl;
